import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ICurrentLightbox } from '../types'
import { DSViewModeAPISymbol, IViewMode } from '@wix/thunderbolt-symbols'

export const CurrentPopup = withDependencies(
	[DSViewModeAPISymbol],
	(viewModeApi: IViewMode): ICurrentLightbox => ({
		isDuringReopen: viewModeApi.isDuringViewModeSwitch,
	})
)
